import { useConfigurationContext } from 'Configuration/useConfigurationContext';
import { createCasPublisher } from 'Workspace/CAS/createCasPublisher';
import { useUserContext } from 'Workspace/UserContext';

export function useCasTelemetryAdapter() {
	const { workspaceConfiguration } = useConfigurationContext();
	const { userDetails } = useUserContext();
	return createCasPublisher(workspaceConfiguration, userDetails);
}
